import axios from "axios";
import $ from "jquery";

const state = {
  placetovisitAll: {},
  placetovisitPost: {},
  publishedPlacestovisitPosts: [],
  unpublishedPlacestovisitPosts: [],
};

const getters = {
  placetovisitAll(state) {
    return state.placetovisitAll;
  },

  placetovisitPost(state) {
    return state.placetovisitPost;
  },

  publishedPlacestovisitPosts(state) {
    return state.publishedPlacestovisitPosts;
  },

  unpublishedPlacestovisitPosts(state) {
    return state.unpublishedPlacestovisitPosts;
  },
};

const mutations = {
  setPlacestovisitAll(state, data) {
    state.placetovisitAll = data;
  },

  setPlacestovisitPost(state, post) {
    state.placetovisitPost = post;
  },

  setPublishedPlacestovisitPosts(state, posts) {
    state.publishedPlacestovisitPosts = posts;
  },

  setUnpublishedPlacestovisitPosts(state, posts) {
    state.unpublishedPlacestovisitPosts = posts;
  },

  deletePublishedPlacestovisitPost(state, id) {
    let index = state.publishedPlacestovisitPosts.findIndex((p) => p.id == id);
    state.publishedPlacestovisitPosts.splice(index, 1);
  },

  deleteUnpublishedPlacestovisitPost(state, id) {
    let index = state.unpublishedPlacestovisitPosts.findIndex((p) => p.id == id);
    state.unpublishedPlacestovisitPosts.splice(index, 1);
  },
};

const actions = {
  async fetchPlacestovisitAll({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/place-visit-page/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setPlacestovisitAll", res.data);
      });
  },

  async fetchPlacestovisitPost({ commit, rootState }, id) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/place-visit-page/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setPlacestovisitPost", res.data);
      });
  },

  async fetchPublishedPlacestovisitPosts({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/place-visit-page/published`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setPublishedPlacestovisitPosts", res.data);
      });
  },

  async fetchUnpublishedPlacestovisitPosts({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/place-visit-page/unpublished`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setUnpublishedPlacestovisitPosts", res.data);
      });
  },

  async publishPlacestovisitPost({ commit, dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/place-visit-page/publish/update?id=${data.id}&publish=${data.publish}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        dispatch("hideSpinnerLoading", null, { root: true });

        if (data.publish) {
          $.alert("post published successfull");
          commit("deleteUnpublishedPlacestovisitPost", data.id);
        } else {
          $.alert("post unpublished successfull");
          commit("deletePublishedPlacestovisitPost", data.id);
        }
      });
  },

  async createPlacestovisitPost({ rootState }, post) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/place-visit-page/create`, post, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updatePlacestovisitPost({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/place-visit-page/update/${data.id}`, data.post, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async deletePlacestovisitPost({ dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/place-visit-page/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("Post deleted successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async uploadPlacevisitPhoto({ rootState }, formData) {
    const accessToken = rootState.authStore.token;
    const apiUrl = process.env.VUE_APP_API_URL;

    return await axios.post(`${apiUrl}/place-visit/photo/upload`, formData, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  async deletePlacevisitPhoto({ rootState }, data) {
    const accessToken = rootState.authStore.token;
    const apiUrl = process.env.VUE_APP_API_URL;

    await axios
      .delete(`${apiUrl}/place-visit/photo/delete`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: data
      })
      .then(() => {
        $.alert("Image deleted !");
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
